// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"9eb64838","146":"7bcfa186","164":"1ec2db48","434":"34121630","686":"d927ce15"}[chunkId] + ".chunk.css";
};